import { render, staticRenderFns } from "./ItemsTypes.vue?vue&type=template&id=0f1ae9e4"
import script from "./ItemsTypes.vue?vue&type=script&lang=ts"
export * from "./ItemsTypes.vue?vue&type=script&lang=ts"
import style0 from "./ItemsTypes.vue?vue&type=style&index=0&id=0f1ae9e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports